export const viewportConfigs = {
  ios: {
    width: 390,
    height: 844,
  },
  android: {
    width: 360,
    height: 800,
  },
  web: {
    width: 1440,
    height: 900,
  },
  selfserve: {
    width: 1440,
    height: 900,
  },
};
